import EventDispatcherModule from '@shcc/modules/EventDispatcherModule';
import TrottlerModule from '@shcc/modules/TrottlerModule';

// Utils
import bindAll from '@shcc/utils/helpers/bindAll';
import { isClient, isTouch } from '@shcc/utils/DeviceUtils';

const RESIZE_INTERVAL = 250;

/**
 *
 * @todo: Implement REM values
 */
class ResizeModule extends EventDispatcherModule {
  constructor() {
    super();

    // Bind handlers
    bindAll(this, ['_resizeHandler', '_trottlerCompleteHandler']);

    this._setValues();
    this._setupTrottler();
    this._setupEventListeners();
  }

  forceUpdate() {
    console.warn('Force update resize module');

    this._setValues();

    this.dispatchEvent('resize', this._getEventPayload());
  }

  forceRefreshValues() {
    this._setValues();
  }

  _setupTrottler() {
    this._trottler = new TrottlerModule({ delay: RESIZE_INTERVAL });
  }

  _setupEventListeners() {
    if (isClient()) {
      window.addEventListener('resize', this._resizeHandler);

      if ('onorientationchange' in window) {
        window.addEventListener('orientationchange', this._resizeHandler);
      }
    }
  }

  _setValues() {
    const viewportDimensions = this._getViewportDimensions();
    const documentDimensions = this._getDocumentDimensions();

    this.viewportWidth = viewportDimensions.width;
    this.viewportHeight = viewportDimensions.height;
    this.documentWidth = documentDimensions.width;
    this.documentHeight = documentDimensions.height;
  }

  _getViewportDimensions() {
    const width = isClient() ? Math.min(window.innerWidth || 0) : 0;
    const height = isClient() ? Math.min(window.innerHeight || 0) : 0;

    return { width, height };
  }

  // prettier-ignore
  _getDocumentDimensions() {
    const width = isClient() ? Math.max(document.body.scrollWidth, document.body.offsetWidth, document.documentElement.clientWidth, document.documentElement.scrollWidth, document.documentElement.offsetWidth) : 0;
    const height = isClient() ? Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) : 0;

    return { width, height };
  }

  _getEventPayload() {
    return {
      context: this,
      viewportWidth: this.viewportWidth,
      viewportHeight: this.viewportHeight,
      documentWidth: this.documentWidth,
      documentHeight: this.documentHeight,
    };
  }

  _resize() {
    this._setValues();

    this._trottler.clear();
    this._trottler.start(this._trottlerCompleteHandler);

    this.dispatchEvent('resize', this._getEventPayload());
  }

  /**
   *
   * Handlers
   */
  _resizeHandler() {
    this._resize();
  }

  _trottlerCompleteHandler() {
    this._setValues();

    this.dispatchEvent('resize:complete', this._getEventPayload());
  }
}

export default ResizeModule;
export const resizeModule = new ResizeModule();
